import React from 'react';
import PrimaryButton from './../Components/Presentation/PrimaryButton/PrimaryButton';
import CancelButton from './../Components/Presentation/CancelButton/CancelButton';
import {Row, Col, Panel} from 'react-bootstrap';
import Parse from 'parse';

class CloseSession extends React.Component {
    currentUser = Parse.User.current();
  
    constructor() {
    super();
    this.state = { someKey: 'someValue' };
  }

  componentDidMount = () => {
    if(this.currentUser === null){
        console.error('Not user logged');
        this.props.history.push( `/pages/log-out`)
        return;
    }
  }

  onCancelHandle = () => {
    this.props.history.push( `dashboard`)
  }

  onCloseSession = () => {
    Parse.User.logOut(this.currentUser.get["userName"]);
    this.props.history.push( `/pages/log-out`)

  }

  render() {
    return (
        <div>
            <div className="vertical-separator-50px"></div>
            <Row>
                <Col md={6} mdOffset={3}>
                    <Panel>
                        <div className="vertical-separator-50px"></div>

                        <h3 className="text-center">¿Estás seguro de cerrar la sesión en dr moons?</h3>
                        
                        <div className="vertical-separator-50px"></div>

                        <div className="row">
                            <div className="col-md-4 col-md-offset-2 text-center">
                                <CancelButton
                                    text="Cancelar"
                                    onClick={this.onCancelHandle}
                                ></CancelButton>
                            </div>
                            <div className="col-md-4 text-center">
                                <PrimaryButton
                                    text="Cerrar sesión"
                                    onClick={this.onCloseSession}
                                >
                                </PrimaryButton>
                            </div>
                        </div>
                        
                        <div className="vertical-separator-50px"></div>

                    </Panel>
                </Col>
            </Row>
            <div className="vertical-separator-50px"></div>
        </div>

    )
  }
}

export default CloseSession;



// WEBPACK FOOTER //
// ./src/views/Account/CloseSession.js